import postCreateMinutes from "@/services/postCreateMinutes";
import { reportError } from "@/utils/reportError";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export interface CreateMinutesData {
  recordingId: string;
}

const usePostCreateMinutes = () => {
  const { mutate, mutateAsync, isPending, isError, error, isSuccess, status } = useMutation<boolean, AxiosError, CreateMinutesData>({
    mutationFn: async (data: CreateMinutesData) => {
      const result = await postCreateMinutes(data);
      if (result instanceof AxiosError) {
        throw result;
      }

      return result;
    },
    mutationKey: ["postCreateMinutes"],
    onError: (error: AxiosError) => {
      reportError(error, {
        eventName: "POST-CREATE-MINUTES",
        properties: {
          reason: `Error with create minutes - ${error?.message}`,
        },
      });
    },
  });

  return { mutate, mutateAsync, isPending, isError, error, isSuccess, status };
};

export default usePostCreateMinutes;
